/*========================================
        Imports!!!
=========================================*/

/*--css--*/
import '../assets/css/dom.css';
import Header from './header.js';
import Footer from './footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/*--img in content--*/
import Main from '../assets/img/img20.webp';

import sprzet1 from '../assets/produkty/zapora.webp';
import sprzet2 from '../assets/produkty/workiPrzeciw.webp';
import sprzet3 from '../assets/produkty/motopompa.webp';
import sprzet4 from '../assets/produkty/ZBPneumatyczny.webp';
import sprzet5 from '../assets/produkty/ZBSferyczny.webp';
import sprzet6 from '../assets/produkty/podlodz.webp';

/*========================================
        Middle!!!
=========================================*/

function Middle() {
    return (
        <>
        <section className='Middle'>
            {/*--stick publicity--*/}
            <section className='publicity'>
                <Row className='entry'>
                    {/*--text--*/}
                    <Col lg={5} md={12} sm={12} className='p-1 describe'>
                        <h1> Sprzęt przeciwpowodziowy</h1>
                        <h5>
                            Odpowiedni sprzęt przeciwpowodziowy pozwala szybko reagować na zagrożenie. W sytuacjach kryzysowych liczy się czas, dlatego warto mieć go pod ręką w każdej firmie czy gospodarstwie.
                        </h5>
                    </Col>
                    {/*--img--*/}
                    <Col lg={6} md={12} sm={12} className='lg-p-3 xs-p-1'>
                        <div className="image-container">
                            <img src={Main} alt='ilustrations of the main theme'/>    
                        </div>
                    </Col >
                </Row>
                {/*--choose the stick--*/}
                <section className='ChooseYour'>
                    <Row className='EquipRow'>
                        <Col className='equipment'>
                            <img src={sprzet1} alt="sprzęt ilustracja"/>
                            <span>Zapory przeciwpowodziowe</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet2} alt="sprzęt ilustracja"/>
                            <span>Worki przeciwpowodziowe</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet3} alt="sprzęt ilustracja"/>
                            <span>Motopomy</span>
                        </Col>
                    </Row>
                    <Row className='EquipRow'>
                        <Col className='equipment'>
                            <img src={sprzet4} alt="sprzęt ilustracja"/>
                            <span>Zbiorniki pneumatyczne</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet5} alt="sprzęt ilustracja"/>
                            <span>Zbiorniki sferyczne</span>
                        </Col>
                        <Col className='equipment'>
                            <img src={sprzet6} alt="sprzęt ilustracja"/>
                            <span>Przyczepa podłodziowa</span>
                        </Col>
                    </Row>
                </section>
            </section>
          </section>
        </>
    );
}

function Equipment() {
    return (
        <>
          <Header />
          <Middle/>
          <Footer/> 
        </>
    );
}

export default Equipment;